export function canUnfold(node) {
    if (! node.isFolded) {
        return false
    }

    const notHidden = n => ! this.isNodeHidden(n)
    return [...this.children(node)].some(notHidden)
}

export function unfoldNode(nodes) {
    for (const node of nodes) {
        node.isFolded = false
    }
}

export function unfoldTree(nodes) {
    for (const node of this.topNodes(nodes)) {
        for (const n of this.dfs(node)) {
            n.isFolded = false
        }
    }
}
